import './shim.ts';


import "./index.scss";
import "bootstrap";
import Popper from 'popper.js';
import './scripts/form';
import './scripts/toast';
import './scripts/nav';
import './scripts/simplebar';
import './scripts/table';
import './scripts/flatpickr';
import './scripts/svelte-components';
import './scripts/lotties';
import './scripts/confirmation';
import './scripts/comments';
import './scripts/companies';
import './scripts/buyback';
import './scripts/users';
import './scripts/extract-request';
import './scripts/form-watcher';
import './scripts/extract-sale';
import './scripts/sticky-watcher';
import './scripts/compliance';
import './scripts/tooltips';
import './scripts/signatureBox';
import './scripts/character-count'
import './scripts/localstorage'

// popover blurry fix
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

// tooltip
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

// popover
$(function () {
    $('[data-toggle="popover"]').popover()
})

// smoothscroll
function clickHandler(e) {
    let href = (e.currentTarget as HTMLElement).getAttribute("href");
    if (href.indexOf("#") === 0) {
        e.preventDefault();
        var { top } = offset(document.querySelector(href));
        var navBottom = 0;

        let top2 = top - navBottom;

        // offset layout sticky header height on application option page
        let layoutHeader = document.querySelector<HTMLElement>(".layout-header");
        if (layoutHeader) {
            // check if scroll over sticky nav
            top2 = top2 - layoutHeader.offsetHeight;
        }
        // offset layout sticky sub header height on application option page
        let layoutSubHeader = document.querySelector<HTMLElement>(
            ".layout-sub-header"
        );
        if (layoutSubHeader) {
            // check if scroll over sticky nav
            top2 = top2 - layoutSubHeader.offsetHeight;
        }

        // temporary solution for IE11
        if (isIE()) {
            window.scrollTo(0, top2);
        } else {
            window.scrollTo({ top: top2, behavior: "smooth" });
        }
    }
}
[].slice.call(document.querySelectorAll("a[data-smoothscroll]")).forEach(el => {
    el.addEventListener("click", clickHandler);
});

function isIE() {
    return navigator.userAgent.match(/Trident\/7\./);
}

function offset(el: HTMLElement) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var marginTop = parseFloat(
        window.getComputedStyle(el).marginTop.replace("px", "")
    );

    return {
        top: rect.top + scrollTop - marginTop,
        left: rect.left + scrollLeft
    };
}

// preload
document.body.classList.remove("preload");